<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    :max-width="width"
    :persistent="isLoading"
  >
    <v-card>
      <v-card-title class="d-flex align-center px-4 py-3">
        <span v-if="title" class="text-h6">
          {{ title }}
        </span>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" @click="doClose()" />
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="py-10">
        <slot name="content" />
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="primary"
          class="text-on-primary"
          @click="$emit('close')"
          :disabled="isLoading"
        >
          {{ cancelBtn }}
        </v-btn>
        <v-btn
          v-if="showActionButton"
          :color="actionColor"
          variant="flat"
          :loading="isLoading"
          :disabled="isLoading"
          :data-test="actionDataTest"
          @click="$emit('action')"
        >
          {{ actionName }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script lang="ts" setup>
import { TranslateResult } from "vue-i18n";
import { computed, ref } from "vue";
import i18n from "@/app/plugins/i18n";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: undefined,
  },
  show: {
    type: Boolean,
    default: undefined,
  },
  prominent: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "",
  },
  actionName: {
    type: String,
    default: "",
  },
  actionColor: {
    type: String,
    default: "blue",
  },
  actionDataTest: {
    type: String,
    default: undefined,
  },
  showActionButton: {
    type: Boolean,
    default: true,
  },
  cancelName: {
    type: String,
    default: "",
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: "50%",
  },
});
const dialogValue = ref(false);
const dialog = computed({
  get(): boolean {
    return props.modelValue ?? props.show ?? dialogValue.value;
  },
  set(value): void {
    if (!value) {
      doClose();
    } else {
      dialogValue.value = true;
      emit("update:modelValue", true);
    }
  },
});
const cancelBtn = computed((): TranslateResult => {
  return props.cancelName ? props.cancelName : i18n.global.t("common.action.cancel");
});
const emit = defineEmits(["close", "action", "update:modelValue"]);
const doClose = () => {
  dialogValue.value = false;
  emit("update:modelValue", false);
  emit("close");
};
</script>
<style scoped>
.v-card-text {
  background-color: #f5f5f5;
}
</style>
